import React from 'react';

import * as _ from "lodash";
import moment from 'moment';
import { AgreementT } from '../../../../types/Job';

export interface IListAgreementsProps {
    agreements: Array<AgreementT>
    currantContent: any
    onClickView?(content: any): void
}

const ListAgreements: React.FC<IListAgreementsProps> = ({ agreements, currantContent, onClickView }): JSX.Element => {
    const sortAgreementsByTimesTamp = (agreements: Array<AgreementT>): Array<AgreementT> => {
        return agreements.sort((a: AgreementT, b: AgreementT) => b.timestamp - a.timestamp)
    }
    const sortAgreements = sortAgreementsByTimesTamp(agreements)

    return (
        <>
            {sortAgreements.map((item: AgreementT, index: number) => {
                return (
                    <div key={index} >
                        <p style={{ fontStyle: 'italic' }} className={`${_.isEqual(item.content, currantContent) ? 'text-primary' : ''}`}>
                            Agreed on {moment(new Date(Number(item.timestamp) * 1000)).format('MM/DD/YYYY HH:mm:ss')} via IP Address {item.ip} User Agent {item.userAgent}
                            {onClickView && currantContent && !_.isEqual(item.content, currantContent) && <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    onClickView(item.content)
                                }} className="text-primary" style={{ cursor: 'pointer' }}> View</a>}
                        </p>
                    </div>
                )
            })}
        </>
    )
}
export default ListAgreements;
export { ListAgreements };